module.exports = {"pipeline":{"name":"pipeline-sence-tab","title":"场景Tab组件","type":"组件的类型，用于展示组件库列表时分类展示 //TODO","only":"组件是否在页面只能有唯一一个，不如分享组件 //TODO"}}


//////////////////
// WEBPACK FOOTER
// ./components/pipeline-sence-tab/package.json
// module id = 569
// module chunks = 2